import { type Infer, object, string } from "superstruct";

import { isoDate, serializeIsoDate } from "../scalar_types/isoDate.js";
import Party, { PartyInfosSerializedSchema } from "./Party.js";

export const CandidateSerializedSchema = object({
    id: string(),
    infos: PartyInfosSerializedSchema,
    createdAt: isoDate,
});

export type CandidateSerialized = Infer<typeof CandidateSerializedSchema>;

export default class Candidate extends Party {
    serialize(): CandidateSerialized {
        if (this.createdAt === null) throw new Error("Candidate has no createdAt");
        return {
            id: this.findId(),
            infos: this.serializeInfos(),
            createdAt: serializeIsoDate(this.createdAt),
        };
    }

    static deserialize(data: CandidateSerialized): Candidate {
        const candidate = new Candidate();
        candidate.id = data.id;
        candidate.createdAt = new Date(data.createdAt);
        candidate.loadInfos(data.infos);
        return candidate;
    }
}
